import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import "../../styles/dash/CreateRoleModal.css";
import { NewRole } from "../../services/dashboard/NewRole";
import LoadingSpinner from "../utility/LoadingSpinner";

interface Props {
    show: boolean;
    onClose: () => void;
    onSuccess: () => void;
}

interface ApiError {
    response?: {
        data?: string;
    };
}

const CreateRoleModal: React.FC<Props> = ({ show, onClose, onSuccess }) => {
    const [roleName, setRoleName] = useState("");
    const [animateOut, setAnimateOut] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setAnimateOut(true);
        setTimeout(() => {
            onClose();
            setAnimateOut(false);
            setRoleName("");
            setErrorMessage("");
        }, 300);
    };

    const handleSubmit = async (e?: React.FormEvent) => {

        if (e) {
            e.preventDefault();
        }

        setLoading(true);
        setErrorMessage("");

        if (!roleName.trim()) {
            setErrorMessage("El nombre del rol es obligatorio");
            setLoading(false);
            return;
        }

        try {
            const response = await NewRole(roleName);

            if (response && response.status === 200) {
                onSuccess();
                handleClose();
            } else {
                setErrorMessage(response?.message || "Error al crear el rol");
            }
        } catch (error: any) {
            const errorMessage = error.message || "Error al crear el rol";
            setErrorMessage(errorMessage);

            console.error("Error en handleSubmit:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show && !animateOut}
            onHide={handleClose}
            centered
            backdrop="static"
            contentClassName={`create-role-modal ${animateOut ? 'modal-exit' : 'modal-enter'}`}
        >
            <Modal.Header closeButton closeVariant="white" className="border-0" />

            <Modal.Body className="create-role-content">
                <h5 className="form-title text-center mb-4">
                    Crear Nuevo Rol
                </h5>

                <Form onSubmit={handleSubmit}>
                    {loading && <LoadingSpinner />}

                    <div className="form-grid">
                        <div className="form-group full-width">
                            <label>Nuevo Rol</label>
                            <input
                                type="text"
                                value={roleName}
                                onChange={(e) => setRoleName(e.target.value)}
                                placeholder="Ej: Administrador"
                                className="form-control"
                            />
                        </div>

                        {/* Mensaje de error */}
                        {errorMessage && (
                            <div className="error-message full-width">
                                {errorMessage}
                            </div>
                        )}

                        <div className="form-group full-width">
                            <button
                                type="button"
                                className="save-button"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                GUARDAR ROL
                            </button>
                        </div>

                        <div className="form-group full-width text-center">
                            <button
                                type="button"
                                className="cancel-button"
                                onClick={handleClose}
                                disabled={loading}
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default CreateRoleModal;